import type { MantineThemeComponents } from '@mantine/core';

export const components: MantineThemeComponents = {
  Button: {
    defaultProps: {
      size: 'sm',
    },
    styles: {
      root: {
        fontWeight: 500,
        transition: 'all 0.2s ease',
        '&:hover': {
          transform: 'translateY(-1px)',
        },
        // Touch-friendly minimum size
        minHeight: '44px',
        '@media (max-width: 48em)': {
          minHeight: '48px',
          fontSize: '16px', // Prevent zoom on iOS
        },
      },
    },
  },
  
  Paper: {
    defaultProps: {
      shadow: 'sm',
      radius: 'md',
      p: 'md',
    },
    styles: {
      root: {
        border: '1px solid',
        borderColor: 'var(--mantine-color-gray-2)',
        transition: 'all 0.2s ease',
        '&:hover': {
          borderColor: 'var(--mantine-color-gray-3)',
          boxShadow: 'var(--mantine-shadow-md)',
        },
      },
    },
  },
  
  Card: {
    defaultProps: {
      shadow: 'sm',
      radius: 'md',
      withBorder: true,
    },
    styles: {
      root: {
        transition: 'all 0.2s ease',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: 'var(--mantine-shadow-lg)',
        },
      },
    },
  },
  
  Table: {
    defaultProps: {
      striped: true,
      highlightOnHover: true,
      withBorder: true,
      withColumnBorders: true,
    },
    styles: {
      root: {
        borderRadius: 'var(--mantine-radius-md)',
        overflow: 'hidden',
      },
      thead: {
        backgroundColor: 'var(--mantine-color-gray-0)',
        fontWeight: 600,
      },
    },
  },
  
  TextInput: {
    defaultProps: {
      size: 'sm',
    },
    styles: {
      input: {
        borderColor: 'var(--mantine-color-gray-3)',
        '&:focus': {
          borderColor: 'var(--mantine-color-admin-6)',
        },
        // Prevent zoom on iOS
        '@media (max-width: 48em)': {
          fontSize: '16px',
          padding: '12px',
        },
      },
    },
  },
  
  Select: {
    defaultProps: {
      size: 'sm',
    },
    styles: {
      input: {
        borderColor: 'var(--mantine-color-gray-3)',
        '&:focus': {
          borderColor: 'var(--mantine-color-admin-6)',
        },
        // Prevent zoom on iOS
        '@media (max-width: 48em)': {
          fontSize: '16px',
          padding: '12px',
        },
      },
    },
  },
  
  Navbar: {
    styles: {
      root: {
        backgroundColor: 'var(--mantine-color-gray-0)',
        borderRight: '1px solid var(--mantine-color-gray-2)',
      },
    },
  },
  
  Header: {
    styles: {
      root: {
        backgroundColor: 'white',
        borderBottom: '1px solid var(--mantine-color-gray-2)',
        boxShadow: 'var(--mantine-shadow-sm)',
      },
    },
  },
  
  Badge: {
    defaultProps: {
      size: 'sm',
      radius: 'sm',
    },
    styles: {
      root: {
        fontWeight: 500,
        textTransform: 'none',
      },
    },
  },
  
  Modal: {
    defaultProps: {
      size: 'md',
      radius: 'md',
      shadow: 'lg',
      fullScreen: false,
    },
    styles: {
      modal: {
        padding: 0,
        // Full screen on mobile
        '@media (max-width: 48em)': {
          margin: 0,
          borderRadius: 0,
          height: '100vh',
          maxHeight: '100vh',
        },
      },
      header: {
        backgroundColor: 'var(--mantine-color-gray-0)',
        borderBottom: '1px solid var(--mantine-color-gray-2)',
        padding: 'var(--mantine-spacing-md)',
      },
      body: {
        padding: 'var(--mantine-spacing-md)',
        '@media (max-width: 48em)': {
          padding: 'var(--mantine-spacing-sm)',
        },
      },
    },
  },
  
  Notification: {
    defaultProps: {
      radius: 'md',
      withCloseButton: true,
    },
    styles: {
      root: {
        borderLeft: '4px solid',
        '&[data-variant="success"]': {
          borderLeftColor: 'var(--mantine-color-green-6)',
        },
        '&[data-variant="error"]': {
          borderLeftColor: 'var(--mantine-color-red-6)',
        },
        '&[data-variant="warning"]': {
          borderLeftColor: 'var(--mantine-color-orange-6)',
        },
        '&[data-variant="info"]': {
          borderLeftColor: 'var(--mantine-color-blue-6)',
        },
      },
    },
  },
};